// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

import type { ComponentInterface } from '@stencil/core'
import { Component, Element, h } from '@stencil/core'

import type { Attributes } from '../../helpers'
import { inheritAriaAttributes } from '../../helpers'

/**
 * The `<qds-table-body>` element encapsulates a set of rows (`<qds-table-row>`
 * elements) indicating that they comprise the body of the table
 * (`<qds-table>`).
 *
 * @see https://quartz.se.com/build/components/table
 */
@Component({
  tag: 'qds-table-body',
  shadow: true,
  styleUrl: 'table-body.css',
})
export class TableBody implements ComponentInterface {
  @Element() private readonly host!: HTMLQdsTableBodyElement

  #inheritedAttributes: Attributes = {}

  public componentWillLoad(): void {
    this.#inheritedAttributes = inheritAriaAttributes(this.host)
  }

  public render() {
    return (
      <tbody
        class="qds-table-body"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...this.#inheritedAttributes}
      >
        <slot />
      </tbody>
    )
  }
}
